module.exports = __webpack_public_path__ + "img/network-and-data-center.920acf4f.jpg";